/**
 * OKS-1040 (PO 3.6 D2) — the posted names of ONE offered product row's
 * catalogue controls (link, pin, detach, clear-pin).
 *
 * Row 0 keeps the legacy names byte-for-byte — top-level `attach_product_id` /
 * `attach_variant_ids[]` / `attach_variant_ids_touched`, and `[0][…]` for the
 * flags — because every pre-1040 form, spec and `MissionsController` path reads
 * them there.
 *
 * ⚠️ Rows ≥ 1 post UNDER their own row (`mission_products_attributes[i][…]`).
 * Before this, row 1's picker posted the SAME top-level `attach_product_id`,
 * so its catalogue link was applied to row 0 — and its pin and detach
 * controls rewrote row 0 too. `MissionsController#apply_row_actions` reads the
 * nested names; they are never permitted into the mass-assignment path, so
 * `product_id` stays reachable only through `MissionProducts::Attacher`.
 */
export interface MissionProductParamNames {
  attachProductId: string
  attachVariantIds: string
  attachVariantIdsTouched: string
  detachProduct: string
  clearVariantPin: string
}

export function missionProductParamNames(
  index: number,
): MissionProductParamNames {
  const row = `mission[mission_products_attributes][${index}]`
  if (index === 0) {
    return {
      attachProductId: "mission[attach_product_id]",
      attachVariantIds: "mission[attach_variant_ids][]",
      attachVariantIdsTouched: "mission[attach_variant_ids_touched]",
      detachProduct: `${row}[detach_product]`,
      clearVariantPin: `${row}[clear_variant_pin]`,
    }
  }
  return {
    attachProductId: `${row}[attach_product_id]`,
    attachVariantIds: `${row}[attach_variant_ids][]`,
    attachVariantIdsTouched: `${row}[attach_variant_ids_touched]`,
    detachProduct: `${row}[detach_product]`,
    clearVariantPin: `${row}[clear_variant_pin]`,
  }
}
